import { getRole } from "@/services/base-api";
import { useAuthenticationStore } from "@/stores/authentication.js";
import { defineStore } from "pinia";

const unFormatBirthday = (day) => {
  const dmy = day.split("-");
  return `${dmy[2]}/${dmy[1]}/${dmy[0]}`;
};

const actions = {
  async setData(data) {
    const authenticationStore = useAuthenticationStore();
    if (data.role) {
      this.role = data.role;
    }
    if (data.contacto) {
      for (let key in data.contacto) {
        if (key === "birthdate") {
          data.contacto[key] = unFormatBirthday(data.contacto[key]);
        }
        if (key !== "photo")
          authenticationStore.user[key] =
            data.contacto[key] || authenticationStore.user[key];
      }
    }
    if (data.states) {
      data.states.sort((a, b) => a.value.localeCompare(b.value));
      this.states = data.states.map((choice) => ({
        ...choice,
        title: choice.name,
      }));
    }
  },
  async getRole() {
    this.loadingRole = true;
    let response;
    try {
      response = await getRole();
    } catch {
      await this.setData({ role: "desconocido" });
    } finally {
      this.loadingRole = false;
    }
    if (response?.data) {
      await this.setData(response.data);
    }
  },
  // async ingresar(user) {
  // const authenticationStore = useAuthenticationStore();
  //   this.loadingSignIn = true;
  //   const response = await ingresar(user || authenticationStore.user);
  //   let data;
  //   if (response.data) {
  //     try {
  //       data = JSON.parse(response.data);
  //       if (!data) {
  //         return;
  //       }
  //       if (data.ingresado) {
  //         await this.setData(data);
  //       }
  //     } catch (e) {
  //       console.error(e);
  //     }
  //   } else {
  //     console.error({ code: 'Could not sign in' });
  //   }
  //   this.loadingSignIn = false;
  //   return data;
  // },
};

export const useAuthorizationStore = defineStore("authorization", {
  state: () => ({
    role: undefined,
    states: [],
    loadingRole: false,
    loadingSignIn: false,
  }),
  getters: {},
  actions,
});
